import { ListOfEmploymentRelation } from './Api/ListOfEmploymentRelation';

export class EmployeeRelation extends ListOfEmploymentRelation {
	public static tryCast(o: any): EmployeeRelation {
		const ret = new EmployeeRelation();
		return Object.assign(ret, o);
	}
}
